module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "shiyao-min.91fcc421.jpg";